export default "/img/MS.2052bc1633ea3d40b986f84819aa8b98.png";